import React from 'react';

const BellIcon = ({ size = 18, ...props }) => (
  <svg
    width={Math.round((size * 16) / 18)}
    height={size}
    viewBox='0 0 16 18'
    fill='currentColor'
    {...props}>
    <path
      d='M 14.519 10.001 L 15.759 4.001 L 12.38 2.001 L 12.794 0 L 9 0 L 8.586 2.001 L 4.38 4.001 L 4.379 4.001 L 3.138 10.001 L 0.827 12.001 L 0 16.002 L 5.692 16.002 C 5.463 17.105 6.126 18 7.173 18 C 8.219 18 9.254 17.105 9.481 16.002 L 15.173 16.002 L 16 12.001 L 14.519 10.001 Z M 13.69 14.001 L 2.31 14.001 L 2.723 12.001 L 5.034 10.001 L 6.07 5 L 8.173 4.001 L 11.967 4.001 L 13.657 5.001 L 12.622 10.001 L 14.104 12.001 L 13.69 14.001 Z'
      fillRule='nonzero'
    />
  </svg>
);

export default BellIcon;
